import React, { useState, useEffect } from "react";
import Navbar from "../components/helpers/Navbar";
import Footer from "../components/helpers/Footer";
import { Form, Button, Row, Col } from "react-bootstrap";
import { emailTemplates } from "../assets/templates/emailTemplates";

const TrimiteMail = () => {
  const [group, setGroup] = useState("membri"); // membri sau voluntari
  const [recipients, setRecipients] = useState([]);
  const [selectedRecipientIds, setSelectedRecipientIds] = useState([]);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);
  const [preview, setPreview] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(null);
  const [searchTerm, setSearchTerm] = useState(""); // Filtru pentru cautare

  // Fetch destinatari (membri / voluntari)
  useEffect(() => {
    const endpoint =
      group === "voluntari"
        ? "https://prdp-api.suport-949.workers.dev/api/voluntari"
        : "https://prdp-api.suport-949.workers.dev/api/membri";

    fetch(endpoint, {
      headers: { Authorization: "Bearer unwantedtok" }
    })
      .then((res) => res.json())
      .then((data) => {
        setRecipients(data);
        setSelectedRecipientIds([]);
        const firstTemplate = emailTemplates[group]?.[0];
        setSelectedTemplateId(firstTemplate?.id || null);
      })
      .catch(() => {
        setRecipients([]);
        setSelectedRecipientIds([]);
      });
  }, [group]);

  // Previzualizare email
  useEffect(() => {
    if (selectedRecipientIds.length === 0 || !selectedTemplateId) {
      setPreview("");
      return;
    }

    const template = emailTemplates[group].find((t) => t.id === selectedTemplateId);
    const first = recipients.find((r) => selectedRecipientIds.includes(r.id));

    if (template && first) {
      setPreview(template.getContent(first));
    } else {
      setPreview("");
    }
  }, [selectedTemplateId, selectedRecipientIds, recipients, group]);

  const toggleRecipient = (id) => {
    setSelectedRecipientIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const selectAll = () => {
    setSelectedRecipientIds(recipients.map((r) => r.id));
  };

  const deselectAll = () => {
    setSelectedRecipientIds([]);
  };

  // Filtru destinatari (nume sau email)
  const filteredRecipients = recipients.filter((r) => {
    const fullName = `${r.prenume} ${r.nume}`.toLowerCase();
    return (
      fullName.includes(searchTerm.toLowerCase()) ||
      r.email.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  const handleSend = async () => {
    if (selectedRecipientIds.length === 0 || !selectedTemplateId) return;

    const template = emailTemplates[group].find((t) => t.id === selectedTemplateId);
    if (!template) return;

    const list = recipients.filter((r) => selectedRecipientIds.includes(r.id));
    setSending(true);
    setSuccess(null);

    try {
      for (const r of list) {
        await fetch("https://prdp-api.suport-949.workers.dev/api/trimite-mail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer secrettoken"
          },
          body: JSON.stringify({
            to: r.email,
            name: `${r.prenume} ${r.nume}`,
            subject: template.subject,
            htmlContent: template.getContent(r)
          })
        });
      }
      setSuccess(true);
    } catch (error) {
      console.error(error);
      setSuccess(false);
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container py-5">
        <div className="container-trimite-mail">
          <h2 className="text-center mb-4 fw-bold text-primary-dark">
            Trimite e-mail către {group === "voluntari" ? "voluntari" : "membri"}
          </h2>

          <Row className="mb-4">
            <Col md={4}>
              <Form.Group>
                <Form.Label><strong>Selectează grup</strong></Form.Label>
                <Form.Select
                  value={group}
                  onChange={(e) => setGroup(e.target.value)}
                >
                  <option value="membri">Membri</option>
                  <option value="voluntari">Voluntari</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label><strong>Alege template email</strong></Form.Label>
                <Form.Select
                  value={selectedTemplateId || ""}
                  onChange={(e) => setSelectedTemplateId(e.target.value)}
                >
                  {emailTemplates[group]?.map((tpl) => (
                    <option key={tpl.id} value={tpl.id}>
                      {tpl.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group>
                <Form.Label><strong>Selectează destinatarii</strong></Form.Label>

                {/* Adaugăm inputul pentru filtrare */}
                <Form.Control
                  type="text"
                  placeholder="Caută după nume sau email..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="mb-2"
                />

                <div style={{
                  maxHeight: "300px",
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  padding: "1rem"
                }}>
                  {filteredRecipients.length === 0 && <p>Niciun rezultat.</p>}
                  {filteredRecipients.map((r) => (
                    <Form.Check
                      key={r.id}
                      type="checkbox"
                      label={`${r.prenume} ${r.nume} (${r.email})`}
                      checked={selectedRecipientIds.includes(r.id)}
                      onChange={() => toggleRecipient(r.id)}
                    />
                  ))}
                </div>

                <div className="mt-2 d-flex gap-2">
                  <Button variant="outline-secondary" size="sm" onClick={selectAll}>
                    Selectează toți
                  </Button>
                  <Button variant="outline-secondary" size="sm" onClick={deselectAll}>
                    Deselectează toți
                  </Button>
                </div>
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-4">
            <Form.Label><strong>Previzualizare email</strong></Form.Label>
            <div
              style={{
                border: "1px solid #eee",
                padding: "24px",
                borderRadius: "12px",
                background: "#fff",
                minHeight: "280px",
                boxShadow: "inset 2px 2px 8px #e4e6eb, inset -2px -2px 8px #fff"
              }}
              dangerouslySetInnerHTML={{ __html: preview }}
            />
          </Form.Group>

          <div className="text-center">
            <Button
              variant="primary"
              size="lg"
              onClick={handleSend}
              disabled={sending || selectedRecipientIds.length === 0}
            >
              {sending
                ? "Se trimit emailurile..."
                : `Trimite email către ${selectedRecipientIds.length} ${group}`}
            </Button>

            {success === true && (
              <div className="text-success mt-3">
                Emailurile au fost trimise cu succes.
              </div>
            )}
            {success === false && (
              <div className="text-danger mt-3">
                Eroare la trimitere. Încearcă din nou.
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TrimiteMail;
